import { memo } from 'react';
import FilePreviewModal from './file-preview';
// import SignOutModal from '@/features/auth/sign-out/components/new-sign-out-modal';

const ModalContainer = memo(() => {
  return (
    <>
      {/* File Preview Modal */}
      <FilePreviewModal />

      {/* Sign Out Modal */}
      {/* <SignOutModal /> */}
    </>
  );
});

ModalContainer.displayName = 'ModalContainer';

export default ModalContainer;
